<template>
    <div>
      <!-- v-if="datoLogin.licencia_perfil != 'estudiante'" -->
      <v-row class="d-flex justify-center">
        <v-col cols="12" sm="12" md="12" class="pb-0">
          <v-alert dense border="left" class="text-center" color="primary" dark>
            <h3>INFORMACIÓN DEL ESTUDIANTE</h3>
          </v-alert>
        </v-col>
  
        <template v-if="filtershow">
          <v-col cols="12" md="2">
            <AutocompleteComp v-model="filter.id_nivel" :items="listNivel" item-text="desc_nivel"
              @change="EventNivel(filter.id_nivel)" textLabel="Nivel" item-value="id" />
          </v-col>
  
          <!-- <v-col cols="12" md="2">
          <AutocompleteComp textLabel="Periodo" v-model="filter.id_periodo" @change="EventPeriodo(filter)"
            :items="listPeriodo" item-value="id" item-text="nombre_periodo" />
        </v-col> -->
  
          <v-col cols="12" md="3">
            <AutocompleteComp textLabel="Grado" v-model="filter.id_grado" @change="EventGrado(filter.id_grado)"
              :items="listGrado" item-value="id" item-text="desc_grado" />
          </v-col>
  
          <v-col cols="12" md="2">
            <AutocompleteComp textLabel="Sección" v-model="filter.id_seccion" @change="EventSeccion()"
              :items="listSeccion" item-value="id" item-text="nombre_seccion" />
          </v-col>
  
          <v-col cols="12" md="5">
            <AutocompleteComp textLabel="Estudiante" v-model="filter.id_alumno" :items="listAlumno" item-value="id"
              item-text="nombre_apellido" @change="listarLibretaNotas" />
          </v-col>
        </template>
        <template v-if="filterfamiliar">
          <v-col cols="12" md="3" sm="4">
            <v-autocomplete label="Estudiante del familiar" v-model="filter.id_alumno" :items="familiarsdata"
              item-text="nombre_persona" item-value="id" @change="listarLibretaNotas">
              <template v-slot:selection="data">
                {{ data.item.ape1_persona + ' ' + data.item.ape2_persona + ', ' + data.item.nombre_persona }}
                <v-chip label small v-bind="data.attrs" :input-value="data.selected">
                  {{ data.item.desc_nivel }} | {{ data.item.desc_grado }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title> {{ data.item.ape1_persona + ' ' + data.item.ape2_persona + ', ' +
                    data.item.nombre_persona }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <v-chip label color="primary" small>
                      {{ data.item.desc_nivel }} | {{ data.item.desc_grado }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
  
              </template>
            </v-autocomplete>
  
          </v-col>
        </template>
  
      </v-row>
  
      <v-expand-transition>
        <v-row v-if="cardsMetricas" class="d-flex justify-center">
          <v-col cols="12" md="auto">
            <v-hover v-slot="{ hover }">
              <v-card @click="ShowMetrica('asistencia')" :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }">
                <v-card-text>
                  <v-row dense class="d-flex text-center">
                    <v-col cols="12">
                      <v-icon color="primary">
                        fas fa-user-check
                      </v-icon>
                    </v-col>
                    <v-col cols="12" class="text-h6 primary--text">
                      Asistencia al colegio
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
  
          </v-col>
          <v-col cols="12" md="auto">
            <v-hover v-slot="{ hover }">
              <v-card @click="ShowMetrica('aprendizaje')" :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }">
                <v-card-text>
                  <v-row dense class="d-flex text-center">
                    <v-col cols="12">
                      <v-icon color="primary">
                        fas fa-book
                      </v-icon>
                    </v-col>
                    <v-col cols="12" class="text-h6 primary--text">
                      Aprendizaje por área
                    </v-col>
                  </v-row>
  
                </v-card-text>
              </v-card>
  
            </v-hover>
          </v-col>
          <v-col cols="12" md="auto">
            <v-hover v-slot="{ hover }">
              <v-card @click="ShowMetrica('curva')" :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }">
                <v-card-text>
                  <v-row dense class="d-flex text-center">
                    <v-col cols="12">
                      <v-icon color="primary">
                        fas fa-chart-line
                      </v-icon>
                    </v-col>
                    <v-col cols="12" class="text-h6 primary--text">
                      Curva de aprendizaje
                    </v-col>
                  </v-row>
  
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="12" md="auto">
            <v-hover v-slot="{ hover }">
              <v-card @click="ShowMetrica('evaluacion')" :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }">
                <v-card-text>
                  <v-row dense class="d-flex text-center">
                    <v-col cols="12">
                      <v-icon color="primary">
                        fas fa-walking
                      </v-icon>
                    </v-col>
                    <v-col cols="12" class="text-h6 primary--text">
                      Progreso según evaluación
                    </v-col>
                  </v-row>
  
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="12" md="auto">
            <v-hover v-slot="{ hover }">
              <v-card @click="ShowMetrica('actividades')" :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }">
                <v-card-text>
                  <v-row dense class="d-flex text-center">
                    <v-col cols="12">
                      <v-icon color="primary">
                        fas fa-tasks
                      </v-icon>
                    </v-col>
                    <v-col cols="12" class="text-h6 primary--text">
                      Actividades realizadas
                    </v-col>
                  </v-row>
  
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-expand-transition>
      <v-row>
        <v-col v-if="Asistencia == true" cols="12">
          <v-expand-transition>
            <v-row class="d-flex transition-fast-in-fast-out v-card--reveal" style="height: 100%;">
  
              <v-col cols="12" class="d-flex">
                <ButtonComp normal-button iconBut="fas fa-arrow-circle-left" text-button="Volver" class-color="red"
                  @click="cardsMetricas = true, Asistencia = false" />
                <v-chip label class="mx-2">
                  <v-icon left small>
                    fas fa-user-check
                  </v-icon>
                  Asistencia al colegio
                </v-chip>
              </v-col>
              <v-col cols="12">
                <AlumnoAsistencia :filter="filter" ref="alumnoAsistencia" />
              </v-col>
  
            </v-row>
          </v-expand-transition>
        </v-col>
        <v-col v-if="Aprendizaje" cols="12">
          <v-expand-transition>
            <v-row class="d-flex transition-fast-in-fast-out v-card--reveal" style="height: 100%;">
              <v-col cols="12" class="d-flex">
                <ButtonComp normal-button iconBut="fas fa-arrow-circle-left" textButton="Volver" class-color="red"
                  @click="cardsMetricas = true, Aprendizaje = false" />
                <v-chip label class="mx-2">
                  <v-icon left small>
                    fas fa-book
                  </v-icon>
                  Aprendizaje por área
                </v-chip>
              </v-col>
              <v-col cols="12">
                <Alumnoaprendizaje :filter="filter" ref="alumnoAprendizaje" />
              </v-col>
            </v-row>
          </v-expand-transition>
        </v-col>
  
        <v-col cols="12" v-if="Curva">
          <v-expand-transition>
            <v-row class="d-flex transition-fast-in-fast-out v-card--reveal" style="height: 100%;">
              <v-col cols="12" class="d-flex">
                <ButtonComp normal-button iconBut="fas fa-arrow-circle-left" textButton="Volver" class-color="red"
                  @click="cardsMetricas = true, Curva = false" />
                <v-chip label class="mx-2">
                  <v-icon left small>
                    fas fa-chart-line
                  </v-icon>
                  Curva de aprendizaje
                </v-chip>
              </v-col>
              <v-col cols="12">
                <Progresschart :filter="filter" ref="progressChart" />
              </v-col>
  
            </v-row>
          </v-expand-transition>
        </v-col>
  
        <v-col cols="12" v-if="evaluacion">
          <v-expand-transition>
            <v-row class="d-flex transition-fast-in-fast-out v-card--reveal" style="height: 100%;">
              <v-col cols="12" class="d-flex">
                <ButtonComp normal-button iconBut="fas fa-arrow-circle-left" textButton="Volver" class-color="red"
                  @click="cardsMetricas = true, evaluacion = false" />
                <v-chip label class="mx-2">
                  <v-icon left small>
                    fas fa-walking
                  </v-icon>
                  Progreso según evaluación
                </v-chip>
              </v-col>
              <v-col cols="12">
  
                <!-- <SomosHabilesChartComp :chartData="somosHabilesLineChart" :chart-options="timeChartOptions" ref="progreSegunEval"
                  :intervals="intervals" :filter="filter"></SomosHabilesChartComp> -->
                  <ProgresoEstudianteContainer :filter="filter" ref="progreSegunEval"></ProgresoEstudianteContainer>
              </v-col>
            </v-row>
          </v-expand-transition>
        </v-col>
        <v-col cols="12" v-if="actividades">
          <v-expand-transition>
            <v-row class="d-flex transition-fast-in-fast-out v-card--reveal" style="height: 100%;">
              <v-col cols="12" class="d-flex">
                <ButtonComp normal-button iconBut="fas fa-arrow-circle-left" textButton="Volver" class-color="red"
                  @click="cardsMetricas = true, actividades = false" />
                <v-chip label class="mx-2">
                  <v-icon left small>
                    fas fa-tasks
                  </v-icon>
                  Actividades realizadas
                </v-chip>
              </v-col>
              <v-col cols="12">
                <Actividadeschart :filter="filter" ref="actividadrefChart" />
              </v-col>
            </v-row>
          </v-expand-transition>
        </v-col>
  
        <!-- <v-col cols="12">
          <AsitenciaMetricas :filter="filter" ref="cardindicadores" />
        </v-col> -->
  
      </v-row>
  
  
  
  
    </div>
  </template>
  
  <script>
  // import NProgress from "nprogress";
  import "nprogress/nprogress.css";
  import { mapMutations } from "vuex";
  // eslint-disable-next-line no-unused-vars
  import axios, { API_URL } from "@/helpers/axios";
  import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
  import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
//   import Actividadeschart from './components/Actividadeschart.vue';
  import Actividadeschart from './Actividadeschart.vue';
  
  // metricas de compromiso
  import AlumnoAsistencia from './Copromisochart.vue';
  
  // metricas de  aprendizaje
  import Alumnoaprendizaje from './Aprendizajechart.vue';
//   import SomosHabilesChartComp from './components/SomosHabilesChart.vue'
//   import MetricasEvaluaciones from './components/MetricaEvaluaciones.vue'
  
  import ProgresoEstudianteContainer from './Progresdaccordletudiant.vue'
  
  // metricas de impacto
  import Progresschart from './Progresschart.vue'
  
//   import ProgressByEval from './components/LineProgressChartProm.vue'
  
  
  export default {
    name: 'MetricsContainer',
    components: {
      ButtonComp,
      Actividadeschart,
      Alumnoaprendizaje,
      AlumnoAsistencia,
    //   SomosHabilesChartComp,
      Progresschart,
    //   ProgressByEval,
      AutocompleteComp,
    //   MetricasEvaluaciones,
      ProgresoEstudianteContainer
    },
    data() {
      return {
        cardsMetricas: true,
        Asistencia: false,
        Aprendizaje: false,
        evaluacion: false,
        actividades: false,
        Curva: false,
        familiarsdata: [],
        filtershow: false,
        filterfamiliar: false,
        BarChartData: {
          labels: ['1er Periodo', '2do Periodo', '3er Periodo'],
          datasets: [
            {
              label: 'Matemáticas',
              backgroundColor: '#41B883',
              data: [0, 0, 0, 0]
            },
            {
              label: 'Ciencias',
              backgroundColor: '#4477CE',
              data: [0, 0, 0, 0]
            },
            {
              label: 'Historia',
              backgroundColor: '#FFC107',
              data: [0, 0, 0, 0]
            }
          ]
        },
        LineCharData: {
          labels: [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12"
          ],
          datasets: [
            {
              label: 'Cubic interpolation (monotone)',
              data: [0, 20, 20, 60, 60, 120, NaN, 180, 120, 125, 105, 110, undefined],
              borderColor: '#41B883',
              fill: false,
              cubicInterpolationMode: 'monotone',
              tension: 0.4
            }, {
              label: 'Cubic interpolation',
              data: [0, 20, 20, 60, 60, 120, NaN, 180, 120, 125, 105, 110, undefined],
              borderColor: '#41B883',
              fill: false,
              tension: 0.4
            }, {
              label: 'Linear interpolation (default)',
              data: [0, 20, 20, 60, 60, 120, NaN, 180, 120, 125, 105, 110, undefined],
              borderColor: '#41B883',
              fill: false
            }
          ],
        },
        timeChartOptions: {},
        somosHabilesLineChart: {},
        somosHabilesEst: [],
        datoLogin: sessionStorage,
        filter: {},
        listNivel: [],
        listPeriodo: [],
        listGrado: [],
        listSeccion: [],
        listAlumno: [],
        ElEstudiante: {},
        dataAreasEval: [],
        dataAreasCom: [],
        somosHabilesStudent: [],
        simuladoresStudent: [],
        notaPeru: null,
        resultadoVerExamen: null,
        intervals: ['1D', '1W', '1M', '1Y'],
      };
    },
  
    methods: {
  
      async ShowMetrica(met) {
        switch (met) {
          case 'asistencia':
            this.Asistencia = true;
            this.cardsMetricas = false;
            break;
          case 'aprendizaje':
            this.Aprendizaje = true;
            this.cardsMetricas = false;
            break;
          case 'curva':
            this.Curva = true;
            this.cardsMetricas = false;
            break;
          case 'evaluacion':
            this.evaluacion = true;
            this.cardsMetricas = false;
            break;
          case 'actividades':
            this.actividades = true;
            this.cardsMetricas = false;
            break;
  
          default:
            break;
        }
      },
  
  
  
      generateLineChartConfig(data) {
        const periods = new Set();
  
        data.forEach(area => {
          if (area.evaluacion) {
            area.evaluacion.forEach(competencia => {
              competencia.periodo.forEach(period => {
                periods.add(period.nombre_periodo);
              });
            });
          }
        });
  
        const uniquePeriods = [...periods];
  
        const datasets = data.map(area => {
          if (!area.evaluacion) {
            return {
              cubicInterpolationMode: 'monotone',
              label: area.desc_area,
              backgroundColor: area.color_area == "#FFFFFF" ? "#A8DEDE" : area.color_area,
              data: new Array(uniquePeriods.length).fill(undefined),
              lineTension: 0.3,
            };
          }
  
          const periodData = uniquePeriods.map(periodName => {
            let totalNotes = 0;
            let countNotes = 0;
  
            area.evaluacion.forEach(competencia => {
              competencia.periodo.forEach(period => {
                if (period.nombre_periodo === periodName) {
                  // se agregó condicional if else
                  // totalNotes += period.nota_alumno;
                  // countNotes++;
                  if (period.nota_alumno == null || period.nota_alumno == undefined) {
  
                    totalNotes = undefined
                    countNotes++;
                  } else {
                    totalNotes += period.nota_alumno;
                    countNotes++;
                  }
                }
              });
            });
  
            return countNotes > 0 ? (totalNotes / countNotes).toFixed(2) : undefined;
          });
  
          return {
            lineTension: 0.3,
            label: area.desc_area,
            backgroundColor: area.color_area == "#FFFFFF" ? "#A8DEDE" : area.color_area,
            // showLine: periodData.every(e=>Number(e) == 0),
            cubicInterpolationMode: 'monotone',
            borderColor: area.color_area == "#FFFFFF" ? "#A8DEDE" : area.color_area,
            data: periodData,
          };
        });
  
        return {
          labels: uniquePeriods,
          datasets: datasets
        };
      },
  
  
      async listarLibretaNotas() {
        this.$nextTick(() => {
          if (this.$refs.alumnoAsistencia) {
            this.$refs.alumnoAsistencia.getAsistenciaClaseChart();
            this.$refs.alumnoAsistencia.getAsistenciaColegioChart();
          }
          if (this.$refs.alumnoAprendizaje) {
            this.$refs.alumnoAprendizaje.getMetricaArea();
            this.$refs.alumnoAprendizaje.fetchDataFromAPI();
          }
          if (this.$refs.progressChart) {
            this.$refs.progressChart.fetchDataFromAPI();
          }
          if (this.$refs.actividadrefChart) {
            this.$refs.actividadrefChart.getActividadesAlumn();
          }
          if (this.$refs.progreSegunEval) {
            this.$refs.progreSegunEval.updateData();
          }
  
  
        });
  
        //   this.$refs.cardindicadores.getActividadesAlumn();
        // this.$refs.cardindicadores.getRankingStuBySec();
      },
  
      EventNivel(id_nivel) {
        this.filter.id_grado = "";
        this.filter.id_seccion = "";
        this.filter.id_alumno = "";
        this.listSeccion = [];
        this.listGrado = [];
        this.listAlumno = [];
        this.ElEstudiante = {};
        this.listDocReq = [];
        this.GetGrado(this.datoLogin.id_colegio, id_nivel);
      },
      EventPeriodo(items) {
        this.listGrado = [];
        this.listSeccion = [];
        this.listAlumno = [];
        this.ElEstudiante = {};
        this.listDocReq = [];
  
        // this.filter.id_nivel = "";
        this.filter.id_grado = "";
        this.filter.id_seccion = "";
        this.filter.id_alumno = "";
        // this.GetNivel(id_periodo);
        this.GetGrado(this.datoLogin.id_colegio, items.id_nivel);
      },
      EventGrado(id_grado) {
        this.filter.id_seccion = "";
        this.filter.id_alumno = "";
        this.listSeccion = [];
        this.listAlumno = [];
        this.ElEstudiante = {};
        this.listDocReq = [];
  
        this.GetSeccion(this.filter.id_colegio, id_grado);
      },
      EventSeccion() {
        this.filter.id_alumno = "";
        this.listAlumno = [];
        this.ElEstudiante = {};
        this.GetAlumnos();
        this.listDocReq = [];
        // this.listarLibretaNotas();
      },
  
      async GetAlumnos() {
        let params = {
          id_ano_lectivo: this.filter.id_ano_lectivo,
          id_colegio: this.filter.id_colegio,
          id_seccion: this.filter.id_seccion,
        };
        let response = await axios.post(`/sistema/integral/getAlumnoSeccion/`, {
          filter: params,
        });
        this.listAlumno = [
          ...response.data.result,
          // { id: 0, nombre_apellido: "Todos" },
        ];
        // console.log("AlumnoSeccion", this.listAlumno);
  
      },
  
  
      async GetNivel(id_periodo) {
        // this.GetPeriodo(this.datoLogin.id_colegio, this.datoLogin.id_ano_lectivo);
        let params = {
          id_periodo,
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        };
        try {
          let response = await axios.post(`/sistema/integral/getNivelAdm/`, {
            filter: params,
          });
  
          this.listNivel = response.data;
        } catch (error) {
          console.log(error);
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      },
  
  
  
      async GetPeriodo(id_nivel, id_colegio, id_ano_lectivo) {
        let params = { id_colegio, id_ano_lectivo };
        try {
          let response = await axios.post(`/sistema/integral/getPeriodo/`, {
            filter: params,
          });
  
          this.listPeriodo = response.data.filter(
            (objeto) => objeto.id_adm_nivel === id_nivel
          );
  
          // console.log(this.listPeriodo);
        } catch (error) {
          console.log(error);
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      },
  
      async GetGrado(id_colegio, id_nivel) {
        let params = { id_colegio, id_nivel };
        try {
          let response = await axios.post(`/sistema/integral/getGradoAdm/`, {
            filter: params,
          });
          this.listGrado = response.data;
        } catch (error) {
          console.log(error);
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      },
  
      async GetSeccion(id_colegio, id_grado) {
        let params = { id_colegio, id_grado };
        try {
          let response = await axios.post(`/sistema/integral/getSeccionAdm/`, {
            filter: params,
          });
          this.listSeccion = response.data;
        } catch (error) {
          console.log(error);
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      },
  
      LimpiarFiltros() {
        this.filter = {
          id_colegio: this.datoLogin.id_colegio,
          id_ano_lectivo: this.datoLogin.id_ano_lectivo,
          id_alumno: "",
          id_periodo: "",
          id_nivel: "",
          id_grado: "",
          id_seccion: "",
          id_usuario: this.datoLogin.id,
        };
      },
      async LoadMain() {
        this.LimpiarFiltros();
        if (this.datoLogin.licencia_perfil == 'familiar') {
          this.filtershow = false;
          this.filterfamiliar = true;
          try {
            let childrenfamiliar = await axios.get(`/libroVirtual/getFamiliar/` + this.datoLogin.id)
            this.familiarsdata = childrenfamiliar.data
          } catch (error) {
            console.error('Hubo un error al buscar el alumno')
          }
        } else if (this.datoLogin.licencia_perfil == 'estudiante') {
          try {
            this.filtershow = false;
            let estudent = await axios.get(`/metricaActividades/consultIdAlumno/` + this.datoLogin.id_persona);
            let response = estudent.data[0];
            this.filter.id_alumno = response.id;
          } catch (error) {
            console.error('Error al consultar el alumno:', error);
          }
        } else {
          this.filtershow = true;
          this.GetNivel(
            null,
            this.datoLogin.id_colegio,
            this.datoLogin.id_ano_lectivo
          );
        }
      },
  
  
  
      ...mapMutations("mensajeSis", ["setEnviarMens"]),
  
    },
  
    mounted() {
      this.LoadMain();
    },
  }
  </script>
  
  <style scoped>
  .headline {
    font-weight: bold;
    color: white;
  }
  </style>